import { FilterItemValue } from "src/app/models";

export class AuctionLotSearchFilterItemTextModel {
  label?: string;
  placeholder?: string;
  value: string;

  regex?: RegExp;
  regexError?: string;
}